import { IOption } from "../../Inputs/CustomSelect/types";

export const selectOptions: IOption[] = [
  {
    option: "KPI",
    value: "KPI",
  },
];
